@if (fieldDef.meta?.value_hidden) {
  <mat-form-field class="flex-auto w-full gt-xs:pr-3">
    <mat-label>
      <span
        class="block overflow-hidden pointer-events-auto text-ellipsis"
        [matTooltip]="fieldDef.label"
        tooltipIfEllipsis
      >
        {{ fieldDef.label }}
      </span>
    </mat-label>
    <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
  </mat-form-field>
} @else {
  <mat-form-field
    TsFieldStyling
    [fieldBackgroundColor]="fieldStyling().color"
    [fieldBold]="fieldStyling().is_bold"
    [targetStylingClass]="commonTargetStylingClass"
    class="flex-auto w-full gt-xs:pr-3"
  >
    <mat-label>
      <span
        class="block overflow-hidden pointer-events-auto text-ellipsis"
        [matTooltip]="fieldDef.label"
        tooltipIfEllipsis
      >
        {{ fieldDef.label }}
      </span>
    </mat-label>
    <input
      matInput
      [matDatepicker]="dp"
      (dateChange)="onDateChange()"
      (blur)="dateBlur($event)"
      [formControl]="date"
      [disabled]="isDisabled"
      [ngClass]="{ disabled: isDisabled }"
      [matTooltip]="showTip"
    />
    <mat-datepicker #dp [disabled]="isDisabled"></mat-datepicker>
    <mat-datepicker-toggle
      [ngStyle]="{ height: '34px', transform: 'translateY(-2px)' }"
      matSuffix
      [for]="dp"
      [disabled]="isDisabled"
    ></mat-datepicker-toggle>
    <mat-error> Date should be in {{ dateDisplayFormat }} format. </mat-error>
  </mat-form-field>
}
